import { render, staticRenderFns } from "./StudentsAttendance.vue?vue&type=template&id=6c1afa74&scoped=true"
import script from "./StudentsAttendance.vue?vue&type=script&lang=js"
export * from "./StudentsAttendance.vue?vue&type=script&lang=js"
import style0 from "./StudentsAttendance.vue?vue&type=style&index=0&id=6c1afa74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1afa74",
  null
  
)

export default component.exports